<template>
    <div class="socialevents">
        <div class="cards">
            <ProgramCard 
                v-for="(card, index) in dataList"
                :key="index"
                :title="card.category"
                :content="card.title"
                :description="card.description"
                :capacity="card.capacity"
                :duration="card.duration"
                :date="formatDate(card.date)"  
            />

        </div>
    </div>
</template>

<script setup>
/* eslint-disable */
import ProgramCard from "./CommonCard/ProgramCard.vue";
import { ref, onMounted,computed, onBeforeUnmount } from "vue";
import axios from 'axios';

    
    let base_url = process.env.VUE_APP_BASE_LIVE_URL
    const dataList = ref([]);
    
    onBeforeUnmount( async () => {
      
    });
    
    onMounted(async () => {
        await listRecords()
    });
  
    const listRecords = async () => {
      try {
        const response = await axios.get('/list_programs.php', { });
        if (response.data.status) dataList.value = response.data.data;
        else console.error(response.data.message);
      } catch (error) {
        console.error(error.message);
      }
    };

   const formatDate = (dateString) => {
    const date = new Date(dateString);

    const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
    const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

    return {
        month: months[date.getMonth()],
        dayNumber: String(date.getDate()).padStart(2, "0"),
        dayText: days[date.getDay()]
    };
    }

    </script>
    

<style scoped lang="scss">
.socialevents {
    max-width: 80%;
    margin: auto;
    margin-top: 5rem;
}

.btn-active {
    background-color: #ED4E24;
    color: #fff;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border: 2px solid #ED4E24;
    border-radius: 60px;
    width: 103px;
}

.btn-not-active {
    background-color: #fff;
    border: 2px solid #9B9A9A;
    color: #9B9A9A;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    border-radius: 60px;
    width: 103px;

}

.buttons {
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
    overflow-x: auto;
}

.cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 5rem;
    margin-top: 5rem;
}
.card-title{
    font-size: 48px; 
    font-weight: 400;
}
@media (max-width: 768px) {
    .socialevents {
        max-width: 100%;
        margin: auto;
        margin-top: 2rem;
    }

    .cards {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        gap: 20px;
        margin-top: 5rem;
    }
    .card-title{
        font-size: 35px; 
    }
}
</style>
